import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import nb from './nb.json';
import en from './en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { nb: { translation: nb }, en: { translation: en } },
    fallbackLng: 'nb',
    detection: { order: ['localStorage', 'navigator'], lookupLocalStorage: 'contrack_lang' },
    interpolation: { escapeValue: false },
  });

export default i18n;
